// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__Q8PWh","info":"Chip_info__H+Emm","attention":"Chip_attention__X3MEf","highlighted":"Chip_highlighted__WI9h-","plain":"Chip_plain__d60AB"};